import { CustomerServiceOffering } from '@sales/modules/details/models/customer-service-offering.model';
import { AssignedCustomerServiceOffering } from '@sales/modules/details/models/assigned-customer-service-offering.model';
import { Product } from './product.model';

export class CustomerServiceProduct extends Product {
  existingCustomerServiceOffering: AssignedCustomerServiceOffering;
  customerServiceOffering: CustomerServiceOffering;
}
